<div
  class="w-8 h-8 rounded-full cursor-pointer transition"
  [class.bg-gray-950/75]="!transparent"
  [class.bg-transparent]="transparent"
>
  <ng-content></ng-content>
</div>
